/* LAMB RANCH — motion controller
   Degrades gracefully: if GSAP or Lenis fail to load, content still shows. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasGSAP = typeof window.gsap !== 'undefined';
  var hasST = hasGSAP && typeof window.ScrollTrigger !== 'undefined';
  var hasLenis = typeof window.Lenis !== 'undefined';
  var html = document.documentElement;

  /* ---- 0. Failsafe: reveal everything if anything goes wrong or takes too long ---- */
  function revealAll() {
    document.querySelectorAll('[data-reveal], [data-reveal-line]').forEach(function (el) {
      el.classList.add('is-in');
    });
  }
  var failsafe = setTimeout(revealAll, 2600);

  /* Only opt into the CSS "hidden" state once we know we can animate it back in */
  var canAnimate = !reduced && ('IntersectionObserver' in window);
  if (canAnimate) html.classList.add('lr-anim');

  /* ================= 1. Smooth scroll (Lenis) ================= */
  var lenis = null;
  if (hasLenis && !reduced) {
    lenis = new Lenis({ duration: 1.05, smoothWheel: true, lerp: 0.1 });
    if (hasST) {
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
      gsap.ticker.lagSmoothing(0);
    } else {
      var raf = function (t) { lenis.raf(t); requestAnimationFrame(raf); };
      requestAnimationFrame(raf);
    }
  }

  function scrollToTarget(target) {
    if (lenis) { lenis.scrollTo(target, { offset: -10 }); }
    else if (target && target.scrollIntoView) { target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' }); }
  }

  /* ================= 2. Anchor links (one-pager) ================= */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#"]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var hash = href.charAt(0) === '#' ? href
             : (href.indexOf('/#') !== -1 ? '#' + href.split('#')[1] : null);
    if (!hash || hash === '#') return;
    var target = document.querySelector(hash);
    if (!target) return;                 // let real cross-page links pass
    e.preventDefault();
    closeNav();
    scrollToTarget(target);
    history.replaceState(null, '', hash);
  });

  /* ================= 3. Header + mobile nav ================= */
  var header = document.querySelector('[data-lr-header]');
  function onScrollHeader() {
    if (!header) return;
    var y = window.scrollY || window.pageYOffset;
    header.classList.toggle('is-solid', y > 40);
  }
  window.addEventListener('scroll', onScrollHeader, { passive: true });
  onScrollHeader();

  function closeNav() { html.classList.remove('lr-nav-open'); if (lenis) lenis.start(); }
  function toggleNav() {
    var open = html.classList.toggle('lr-nav-open');
    if (lenis) { open ? lenis.stop() : lenis.start(); }
  }
  document.querySelectorAll('[data-lr-burger]').forEach(function (b) {
    b.addEventListener('click', toggleNav);
  });
  window.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });

  /* ================= 4. Reveals ================= */
  function initReveals() {
    var items = document.querySelectorAll('[data-reveal], [data-reveal-line]');
    if (!items.length) return;
    if (!canAnimate) { revealAll(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var el = en.target;
          var delay = parseFloat(el.getAttribute('data-reveal-delay') || 0);
          setTimeout(function () { el.classList.add('is-in'); }, delay * 1000);
          io.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ================= 5. GSAP scene work (parallax, counters, marquee, rail) ================= */
  function initGSAP() {
    if (!hasST || reduced) return;
    gsap.registerPlugin(ScrollTrigger);

    /* hero image parallax */
    gsap.utils.toArray('[data-parallax-hero]').forEach(function (el) {
      gsap.to(el, {
        yPercent: 14, ease: 'none',
        scrollTrigger: { trigger: el.closest('section') || el, start: 'top top', end: 'bottom top', scrub: true }
      });
    });

    /* framed images: settle scale + drift */
    gsap.utils.toArray('[data-parallax-img]').forEach(function (el) {
      gsap.fromTo(el, { yPercent: -6, scale: 1.12 }, {
        yPercent: 6, scale: 1.12, ease: 'none',
        scrollTrigger: { trigger: el.closest('section') || el, start: 'top bottom', end: 'bottom top', scrub: true }
      });
    });

    /* count-up stats */
    gsap.utils.toArray('[data-count]').forEach(function (el) {
      var to = parseFloat(el.getAttribute('data-count'));
      var dec = (el.getAttribute('data-count-dec') === '1');
      var obj = { v: 0 };
      ScrollTrigger.create({
        trigger: el, start: 'top 85%', once: true,
        onEnter: function () {
          gsap.to(obj, {
            v: to, duration: 1.8, ease: 'power2.out',
            onUpdate: function () {
              el.firstChild.textContent = dec ? obj.v.toFixed(1) : Math.round(obj.v).toLocaleString();
            }
          });
        }
      });
    });

    /* marquee */
    gsap.utils.toArray('[data-marquee]').forEach(function (track) {
      var w = track.scrollWidth / 2;
      gsap.to(track, { x: -w, duration: 26, ease: 'none', repeat: -1,
        modifiers: { x: function (x) { return (parseFloat(x) % w) + 'px'; } } });
    });

    ScrollTrigger.refresh();
  }

  /* rail progress (native scroll-snap, no pin) */
  function initRail() {
    document.querySelectorAll('[data-rail]').forEach(function (rail) {
      var bar = rail.parentElement.querySelector('[data-rail-bar]');
      if (!bar) return;
      rail.addEventListener('scroll', function () {
        var max = rail.scrollWidth - rail.clientWidth;
        var p = max > 0 ? rail.scrollLeft / max : 0;
        bar.style.transform = 'translateX(' + (p * (rail.parentElement.querySelector('.lr-rail-progress').clientWidth - bar.clientWidth)) + 'px)';
      }, { passive: true });
    });
  }

  /* running head: current chapter */
  function initRunhead() {
    var rh = document.querySelector('[data-runhead]');
    if (!rh || !hasST || reduced) return;
    var label = rh.querySelector('b');
    document.querySelectorAll('[data-chapter]').forEach(function (sec) {
      ScrollTrigger.create({
        trigger: sec, start: 'top center', end: 'bottom center',
        onToggle: function (self) { if (self.isActive && label) label.textContent = sec.getAttribute('data-chapter'); }
      });
    });
  }

  /* live YouTube subscriber counter — degrades to fallback text on any error */
  function initYouTube() {
    document.querySelectorAll('[data-yt-subs]').forEach(function (el) {
      var cid = el.getAttribute('data-yt-channel');
      if (!cid) return;
      var key = el.getAttribute('data-yt-key');
      var fmt = function (n) { return Number(n).toLocaleString('en-US'); };
      function animate(to) {
        to = parseInt(to, 10); if (!to) return;
        if (hasGSAP && !reduced) {
          var o = { v: parseInt((el.textContent || '0').replace(/[^0-9]/g, '')) || 0 };
          gsap.to(o, { v: to, duration: 1.6, ease: 'power2.out',
            onUpdate: function () { el.textContent = fmt(Math.round(o.v)); } });
        } else { el.textContent = fmt(to); }
      }
      function viaService() {
        fetch('https://api.socialcounts.org/youtube-live-subscriber-count/' + cid)
          .then(function (r) { return r.json(); })
          .then(function (d) { var c = d.est_sub || d.subscriberCount; if (c) animate(c); })
          .catch(function () {});
      }
      function load() {
        if (key) {
          fetch('https://www.googleapis.com/youtube/v3/channels?part=statistics&id=' + cid + '&key=' + key)
            .then(function (r) { return r.json(); })
            .then(function (d) {
              var s = d.items && d.items[0] && d.items[0].statistics;
              if (s && s.subscriberCount) animate(s.subscriberCount); else viaService();
            }).catch(viaService);
        } else { viaService(); }
      }
      load();
      setInterval(load, 60000); // refresh every minute
    });
  }

  /* ================= boot ================= */
  function boot() {
    clearTimeout(failsafe);
    initReveals();
    initGSAP();
    initRail();
    initRunhead();
    initYouTube();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  window.addEventListener('load', function () { if (hasST) ScrollTrigger.refresh(); });

  /* Shopify theme editor: re-init when a section is re-rendered */
  document.addEventListener('shopify:section:load', function () {
    if (hasST) { ScrollTrigger.refresh(); }
    initReveals();
  });
})();
